/**
 * 智能选型预算区间 — 按语言对应当地常用货币
 * 国外版 6 档：低于 $3k / $3k–6k / $6k–10k / $10k–20k / 高于 $20k / 暂未确定
 */
export const selectorBudgetLocales = {
  zh: {
    selectorBudget1: "2万元以内",
    selectorBudget2: "2万－5万元",
    selectorBudget3: "5万－10万元",
    selectorBudget4: "10万元以上",
  },
  en: {
    selectorBudget1: "Below USD 3,000",
    selectorBudget2: "USD 3,000–6,000",
    selectorBudget3: "USD 6,000–10,000",
    selectorBudget4: "USD 10,000–20,000",
    selectorBudget5: "Above USD 20,000",
    selectorBudget6: "Not decided yet",
  },
  de: {
    selectorBudget1: "Unter 3.000 €",
    selectorBudget2: "3.000–6.000 €",
    selectorBudget3: "6.000–10.000 €",
    selectorBudget4: "10.000–20.000 €",
    selectorBudget5: "Über 20.000 €",
    selectorBudget6: "Noch nicht festgelegt",
  },
  pt: {
    selectorBudget1: "Até R$ 15.000",
    selectorBudget2: "R$ 15.000–30.000",
    selectorBudget3: "R$ 30.000–50.000",
    selectorBudget4: "R$ 50.000–100.000",
    selectorBudget5: "Acima de R$ 100.000",
    selectorBudget6: "Ainda não definido",
  },
  es: {
    selectorBudget1: "Menos de 3.000 €",
    selectorBudget2: "3.000–6.000 €",
    selectorBudget3: "6.000–10.000 €",
    selectorBudget4: "10.000–20.000 €",
    selectorBudget5: "Más de 20.000 €",
    selectorBudget6: "Aún no definido",
  },
  fr: {
    selectorBudget1: "Moins de 3 000 €",
    selectorBudget2: "3 000–6 000 €",
    selectorBudget3: "6 000–10 000 €",
    selectorBudget4: "10 000–20 000 €",
    selectorBudget5: "Plus de 20 000 €",
    selectorBudget6: "Pas encore décidé",
  },
  it: {
    selectorBudget1: "Meno di 3.000 €",
    selectorBudget2: "3.000–6.000 €",
    selectorBudget3: "6.000–10.000 €",
    selectorBudget4: "10.000–20.000 €",
    selectorBudget5: "Oltre 20.000 €",
    selectorBudget6: "Non ancora deciso",
  },
  hi: {
    selectorBudget1: "₹2 लाख से कम",
    selectorBudget2: "₹2–5 लाख",
    selectorBudget3: "₹5–10 लाख",
    selectorBudget4: "₹10–20 लाख",
    selectorBudget5: "₹20 लाख से अधिक",
    selectorBudget6: "अभी तय नहीं",
  },
  ru: {
    selectorBudget1: "До 250 000 ₽",
    selectorBudget2: "250 000–500 000 ₽",
    selectorBudget3: "500 000–800 000 ₽",
    selectorBudget4: "800 000–1 600 000 ₽",
    selectorBudget5: "Свыше 1 600 000 ₽",
    selectorBudget6: "Пока не определён",
  },
  ko: {
    selectorBudget1: "300만원 이하",
    selectorBudget2: "300만–600만원",
    selectorBudget3: "600만–1,000만원",
    selectorBudget4: "1,000만–2,000만원",
    selectorBudget5: "2,000만원 이상",
    selectorBudget6: "아직 미정",
  },
  ja: {
    selectorBudget1: "30万円以内",
    selectorBudget2: "30万～60万円",
    selectorBudget3: "60万～100万円",
    selectorBudget4: "100万～200万円",
    selectorBudget5: "200万円以上",
    selectorBudget6: "未定",
  },
  th: {
    selectorBudget1: "ต่ำกว่า 100,000 บาท",
    selectorBudget2: "100,000–200,000 บาท",
    selectorBudget3: "200,000–350,000 บาท",
    selectorBudget4: "350,000–700,000 บาท",
    selectorBudget5: "มากกว่า 700,000 บาท",
    selectorBudget6: "ยังไม่ตัดสินใจ",
  },
  tr: {
    selectorBudget1: "100.000 TL altı",
    selectorBudget2: "100.000–200.000 TL",
    selectorBudget3: "200.000–350.000 TL",
    selectorBudget4: "350.000–700.000 TL",
    selectorBudget5: "700.000 TL üzeri",
    selectorBudget6: "Henüz belirlenmedi",
  },
  vi: {
    selectorBudget1: "Dưới 70 triệu đồng",
    selectorBudget2: "70–140 triệu đồng",
    selectorBudget3: "140–230 triệu đồng",
    selectorBudget4: "230–460 triệu đồng",
    selectorBudget5: "Trên 460 triệu đồng",
    selectorBudget6: "Chưa xác định",
  },
  nl: {
    selectorBudget1: "Onder € 3.000",
    selectorBudget2: "€ 3.000–6.000",
    selectorBudget3: "€ 6.000–10.000",
    selectorBudget4: "€ 10.000–20.000",
    selectorBudget5: "Boven € 20.000",
    selectorBudget6: "Nog niet bepaald",
  },
  id: {
    selectorBudget1: "Di bawah Rp 45 juta",
    selectorBudget2: "Rp 45–90 juta",
    selectorBudget3: "Rp 90–150 juta",
    selectorBudget4: "Rp 150–300 juta",
    selectorBudget5: "Di atas Rp 300 juta",
    selectorBudget6: "Belum ditentukan",
  },
  ar: {
    selectorBudget1: "أقل من 11,000 درهم",
    selectorBudget2: "11,000–22,000 درهم",
    selectorBudget3: "22,000–37,000 درهم",
    selectorBudget4: "37,000–73,000 درهم",
    selectorBudget5: "أكثر من 73,000 درهم",
    selectorBudget6: "لم يُحدد بعد",
  },
  pl: {
    selectorBudget1: "Poniżej 12 000 zł",
    selectorBudget2: "12 000–24 000 zł",
    selectorBudget3: "24 000–40 000 zł",
    selectorBudget4: "40 000–80 000 zł",
    selectorBudget5: "Powyżej 80 000 zł",
    selectorBudget6: "Jeszcze nie ustalono",
  },
};
